var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.9591 12.9062C2.9574 11.6831 3.19777 10.4718 3.66639 9.34211C4.135 8.21238 4.82258 7.18659 5.68948 6.32385C6.55639 5.46111 7.58548 4.77847 8.71745 4.3153C9.84945 3.85214 11.0618 3.61759 12.2848 3.62518C17.3883 3.66311 21.4703 7.90503 21.4703 13.0227V13.9374C21.4703 18.5543 22.4362 21.2334 23.2869 22.6976C23.3786 22.8541 23.4274 23.032 23.4284 23.2132C23.4294 23.3946 23.3825 23.5729 23.2924 23.7304C23.2025 23.8878 23.0727 24.0187 22.9159 24.11C22.7592 24.2012 22.5813 24.2495 22.3999 24.2499H2.02847C1.84714 24.2495 1.66912 24.2012 1.5124 24.1099C1.35566 24.0187 1.22578 23.8878 1.13581 23.7302C1.04586 23.5728 0.999012 23.3945 1.00002 23.2131C1.00102 23.0317 1.04983 22.8538 1.14152 22.6975C1.99272 21.2331 2.9591 18.5541 2.9591 13.9374V12.9062Z",
    stroke: "#7A5AF8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08917 24.25V25.2812C8.08917 26.3752 8.52377 27.4245 9.29736 28.198C10.071 28.9716 11.1202 29.4062 12.2142 29.4062C13.3081 29.4062 14.3574 28.9716 15.131 28.198C15.9045 27.4245 16.3392 26.3752 16.3392 25.2812V24.25",
    stroke: "#7A5AF8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 2,
    r: 1.5,
    stroke: "#7A5AF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotify);
export default __webpack_public_path__ + "static/media/Notify.7ac061f169a1c649d1a39845ca8b1bd7.svg";
export { ForwardRef as ReactComponent };